const SSO_BASE_URL = process.env.GATSBY_SSO_URL
const SSO_CLIENT_ID = process.env.GATSBY_SSO_CLIENT_ID
const SSO_CALLBACK_URI = process.env.GATSBY_SSO_REDIRECT_URI

if (!SSO_BASE_URL)
  throw new Error(
    "Missing required environment variable. Please add a SSO_BASE_URL."
  )

const SSOURL = (to, from) => {
  const url = new URL(to, SSO_BASE_URL)

  const searchParams = url.searchParams
  searchParams.append("client_id", SSO_CLIENT_ID)
  searchParams.append("redirect_uri", SSO_CALLBACK_URI)
  if (from) searchParams.append("target_uri", from)

  return url
}

//global: signuplink
export const signupLink = pathname => SSOURL("/create-account", pathname)

//global: signinlink
export const signinLink = pathname => SSOURL("/sign-in", pathname)
